import SimpleTable from '@/components/Molecules/Table/SimpleTable.component';
import ReportResult from '@/pages/reports/ReportResult.page';
import { createFileRoute, useParams, useSearch, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'

type RunReportFilters = {
  customer: number | undefined;
  category: string | undefined;
  status: number | undefined;
  filter: string | undefined;
  queryKey: string | undefined;
  showRecent: boolean | undefined;
  newReport: boolean | undefined;
}

export const Route = createFileRoute('/_auth/runReport')({
  component: RouteComponent,
  validateSearch: (search: RunReportFilters) => {
    return z.object({
      customer: z.number().optional(),
      category: z.string().optional(),
      status: z.number().optional(),
      filter: z.string().optional(),
      queryKey: z.string().optional(),
      showRecent: z.boolean().optional(),
      newReport: z.boolean().optional(),
    }).parse(search)
  },
  loaderDeps: ({ search }) => ({
    customer: search.customer,
    category: search.category,
    status: search.status,
    filter: search.filter,
    queryKey: search.queryKey,
    showRecent: search.showRecent,
    newReport: search.newReport,
  }),
  loader: async ({ deps }) => {
    if (typeof window !== 'undefined') {
      console.log(deps)
      localStorage.setItem('ReportPath', JSON.stringify(deps));
    }
  }
})

function RouteComponent() {

  return (
    <>
      <ReportResult />
    </>
  )
}
